/** @jsxImportSource @emotion/react */
import { useSearchParams } from 'react-router-dom'
import Typography from '@mui/material/Typography'
import React, { useState } from 'react'
import { usePlatformsAndSubjects } from 'hooks/usePlatformsAndSubjects'
import { PageLoader } from 'components/PageLoader'
import TabsNavigation from 'components/TabsNavigation'
import { DescriptionForm, DescriptionPages } from 'components/DescriptionForm'
import { TabsItem } from 'types/tabsItem'
import { QUERY_PARAM } from 'pagesNew/Users'
import { AITestTypeEnum } from '__generatedTypes__/globalTypes'
import * as classes from './styles'
import { TestsList } from './TestsList'

const TABS: Array<{ id: AITestTypeEnum; title: string }> = [
  {
    id: AITestTypeEnum.VideoTest,
    title: 'Video Prompt',
  },
  {
    id: AITestTypeEnum.TextTest,
    title: 'Text Prompt',
  },
]

export const ResponseTests = () => {
  const [searchParams, setSearchParams] = useSearchParams()
  const { selectedPlatform } = usePlatformsAndSubjects({})
  const [activeTab, setActiveTab] = useState<TabsItem>(() => {
    const tabId = searchParams.get(QUERY_PARAM)
    return TABS.find(({ id }) => id === tabId) || TABS[0]
  })

  const handleChangeTab = (activeTab: TabsItem) => {
    setSearchParams((prev) => ({
      ...Object.fromEntries(prev.entries()),
      [QUERY_PARAM]: activeTab.id,
    }))
    setActiveTab(activeTab)
  }

  if (!selectedPlatform) {
    return <PageLoader />
  }

  return (
    <section css={classes.container}>
      <Typography css={classes.header} variant="title3">
        Video/Text Response Tests
      </Typography>

      <DescriptionForm page={DescriptionPages.ResponseTest} />

      <TabsNavigation css={classes.tabs} tabs={TABS} value={activeTab} onChange={handleChangeTab} />

      <TestsList type={activeTab.id as AITestTypeEnum} />
    </section>
  )
}
